<template>
  <table class="summary-chart-table">
    <tr>
      <td class="summary-chart-table__date-time-header">
        {{dateTimeTitle}}
      </td>
      <td
        class="summary-chart-table__views-header"
        v-for="(item, key) in data"
        :key="`header${key}`"
      >
        {{headers[Object.keys(item)[0]]}}
      </td>
    </tr>

    <tr v-for="(item, key) in viewsDates" :key="key">

      <td class="summary-chart-table__date-time">
        {{item}}
      </td>

      <td
        v-for="(itemData, itemKey) in viewsData"
        class="summary-chart-table__value"
        contenteditable="true"
        @keyup.enter="onEnter($event)"
        @blur="updateChartItem($event, key, itemKey)"
        :key="`${key}-${itemKey}`"
      >
        {{itemData[key][1]}}
      </td>

    </tr>
  </table>
</template>

<script>
  import { UPDATE_AUDIT_CHART } from "../../../../../store/actions/audit";

  export default {
    name: "InvolvementTable",
    props: {
      data: {
        type: Array
      },
      chartName: {
        type: String
      }
    },
    data() {
      return {
        headers: this.$t('feed.audit.edit.summary.headers'),
      };
    },
    computed: {
      dateTimeTitle() {
        return this.$t('feed.audit.edit.summary.date');
      },
      viewsDates(){
        return this.data[0].likes.graph_data.map(item => item[0]);
      },
      viewsData() {
        return {
          likes: this.data[0].likes.graph_data,
          reposts: this.data[1].reposts.graph_data,
          comments: this.data[2].comments.graph_data
        };
      }
    },
    methods: {
      onEnter(event) {
        event.target.blur();
      },
      updateChartItem(event, index, key) {
        const value = parseInt(event.target.innerHTML.trim());
        event.target.innerHTML = value;

        this.$store.dispatch(UPDATE_AUDIT_CHART, {
          chart: this.chartName,
          value,
          index,
          key
        })
          .then(() => {
            this.$notify({
              title: this.$t('feed.audit.edit.notify.title'),
              message: this.$t('feed.audit.edit.notify.text'),
              type: 'success',
              duration: 1500,
              showClose: false
            });
          });
      }
    }
  }
</script>

<style>
  .summary-chart-table {
    width: 100%;
    margin-top: 34px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    border-collapse: collapse;
  }

  .summary-chart-table td {
    height: 40px;
    padding: 0 0 0 20px;
    border: 2px solid #EBEBEB;
    box-sizing: border-box;
  }

  .summary-chart-table .summary-chart-table__date-time-header {
    width: 20%;
    color: #5E6D82;
    border-left: transparent;
  }

  .summary-chart-table__views-header {
    width: 20%;
    color: #5E6D82;
    cursor: default;
  }

  .summary-chart-table .summary-chart-table__views-header {
    border-right: transparent;
  }

  .summary-chart-table .summary-chart-table__value {
    border-right: transparent;
  }

  .summary-chart-table .summary-chart-table__date-time {
    border-left: transparent;
  }

  .summary-chart-table__date-time,
  .summary-chart-table__value {
    color: #5E6D82;
  }

  .summary-chart-table__value {
    cursor: text;
  }

  .summary-chart-table__value:hover {
    background-color: #f5f7fa;
  }

  .summary-chart-table__value:focus {
    outline: none;
    background-color: #f5f7fa;
  }
</style>
